module.exports = __webpack_public_path__ + "static/img/Visualization21.24100a63.png";